/** Append appointmentId to a path as a query param (preserves existing query). */
export function withAppointmentIdQuery(
  path: string,
  appointmentId?: string | null
): string {
  const id = String(appointmentId ?? "").trim();
  if (!id) return path;
  const [base, existing = ""] = path.split("?");
  const params = new URLSearchParams(existing);
  params.set("appointmentId", id);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function readAppointmentIdFromSearch(
  searchParams: URLSearchParams | { get: (k: string) => string | null }
): string | null {
  const id = String(searchParams.get("appointmentId") ?? "").trim();
  return id || null;
}

export function appointmentIdPayload(appointmentId?: string | null): {
  appointmentId?: string;
} {
  const id = String(appointmentId ?? "").trim();
  return id ? { appointmentId: id } : {};
}
